export const ONLY_AUTORIZED = true;
export const DEFAULT_LOCALE = 'ru_RU';
export const DEFAULT_LOCALE_SHORT = 'ru';
// export const DEFAULT_LOCALE_SHORT = 'en';
export const DASHBOARD_PAGE = '/dashboard/';
export const APP_START_ROUTE = '/violations';
export const HIDE_SYSTEM_ROUTE = true;

const defaultDomainName = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_NAME ? window.APP_DOMAIN_NAME : (process.env.REACT_APP_DOMAIN_NAME || '0.0.0.0');
const defaultPort = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_PORT ? window.APP_DOMAIN_PORT : (process.env.REACT_APP_DOMAIN_PORT || 8080);
const defaultWSPort = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_WS_PORT ? window.APP_DOMAIN_WS_PORT : (process.env.REACT_APP_DOMAIN_WS_PORT || 8080);
const defaultProtocol = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_PROTOCOL ? window.APP_DOMAIN_PROTOCOL : (process.env.REACT_APP_DOMAIN_PROTOCOL || 'http');
const entryPoint = process.env.NODE_ENV === 'production' && window.APP_ENTRY_POINT ? window.APP_ENTRY_POINT : (process.env.REACT_APP_ENTRY_POINT || '');
const defaultUrl = `${defaultProtocol}://${defaultDomainName}${defaultPort ? `:${defaultPort}` : ''}`;
const buildVersion = process.env.NODE_ENV === 'production' && window.APP_BUILD_VERSION ? window.APP_BUILD_VERSION : (process.env.REACT_APP_BUILD_VERSION || '1.0.0.0.0');

export const BUILD_VERSION = buildVersion;
export const WS_URL = `ws://${defaultDomainName}:${defaultWSPort}`;
export const BACKEND_URL = defaultUrl + entryPoint;
export const BACKEND_MDS_URL = `${defaultUrl}/micromobility/mds`;
export const MOCK_MDS_URL = 'http://localhost:9000/micromobility/mds';
export const ITEMS_OF_PAGE = [{ value: 5, name: 5 }, { value: 10, name: 10 }, { value: 25, name: 25 }, { value: 50, name: 50 }];
// export const DEFAULT_ITEMS_OF_PAGE = 25;
// export const DEFAULT_ITEMS_OF_PAGE = 10;
export const DEFAULT_ITEMS_OF_PAGE = 10;

export const LOADING_DELAY = 500;

export const DEFAULT_DATE_RANGE_SUBTRACT_COUNT = 1;
export const DEFAULT_DATE_RANGE_SUBTRACT_TYPE = 'month';
// size in byte
export const MAX_UPLOAD_FILE_SIZE = 2 * 1024 * 1024;
export const MAX_UPLOAD_FILE_COUNT = 20;
export const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE || '';
export const SUPPORT_MAIL = process.env.REACT_APP_SUPPORT_MAIL || '';

export const DEFAULT_CHART_COLORS = [
  '#3b7ddd',
  '#fd7e14',
  '#dc3545',
  '#28a745',
  '#6b0392',
  '#d17905',
  '#453d3f',
  '#f05b4f',
  '#dda458',
  '#eacf7d',
  '#86797d',
  '#b2c326',
  '#6188e2',
  '#a748ca',
  '#44f0c2',
];

export const STATUS_COLOR = {
  GREEN: 'green',
  BLUE: 'blue',
  YELLOW: 'yellow',
  VIOLET: 'violet',
  RED: 'red',
  LIGHT_BLUE: 'light-blue',
  TURQUOISE: 'turquoise',
  GRAY: 'gray',
};

export const STATUS_COLOR_CODE = {
  [STATUS_COLOR.GREEN]: '#08A835',
  [STATUS_COLOR.BLUE]: '#1665A7',
  [STATUS_COLOR.YELLOW]: '#FFA41F',
  [STATUS_COLOR.VIOLET]: '#6C60D0',
  [STATUS_COLOR.RED]: '#DE0F0F',
  [STATUS_COLOR.LIGHT_BLUE]: '#26ABC9',
  [STATUS_COLOR.TURQUOISE]: '#0A9A82',
  [STATUS_COLOR.GRAY]: '#758192',
};

export const REPORT_STATUS = {
  AWAIT: 1,
  PROCESS: 2,
  END: 3,
  ERROR: 4,
};

export const REPORT_STATUS_NAMES = {
  [REPORT_STATUS.AWAIT]: STATUS_COLOR.GRAY,
  [REPORT_STATUS.PROCESS]: STATUS_COLOR.BLUE,
  [REPORT_STATUS.END]: STATUS_COLOR.GREEN,
  [REPORT_STATUS.ERROR]: STATUS_COLOR.RED,
};

export const REPORT_TEMPLATE_STATUS = {
  ACTIVE: 1,
  ARCHIVE: 2,
};

export const REPORT_TEMPLATE_STATUS_NAMES = {
  [REPORT_TEMPLATE_STATUS.ACTIVE]: STATUS_COLOR.GREEN,
  [REPORT_TEMPLATE_STATUS.ARCHIVE]: STATUS_COLOR.GRAY,
};

export const NOTIFICATION_STATUS_MARK = {
  READ: 0,
  UNREAD: 1,
};

export const NOTIFICATION_STATUS_MARK_LIST = [
  { value: NOTIFICATION_STATUS_MARK.READ, nameId: 'notification.mark.status.1' },
  { value: NOTIFICATION_STATUS_MARK.UNREAD, nameId: 'notification.mark.status.2' },
];

export const VIOLATION_STATUS = {
  CREATED: 'created',
  ISSUED: 'issued',
  INSPECTED: 'inspected',
  IN_PROCESS: 'in_process',
  UPLOADED: 'uploaded',
  APPROVED: 'approved',
  CANCELLED: 'cancelled',
  CANCELED: 'cancelled',
};

export const VIOLATION_STATUS_NAMES = {
  [VIOLATION_STATUS.CREATED]: STATUS_COLOR.LIGHT_BLUE,
  [VIOLATION_STATUS.ISSUED]: STATUS_COLOR.GREEN,
  [VIOLATION_STATUS.CANCELLED]: STATUS_COLOR.GREEN,
  [VIOLATION_STATUS.INSPECTED]: STATUS_COLOR.GREEN,
  [VIOLATION_STATUS.IN_PROCESS]: STATUS_COLOR.GREEN,
  [VIOLATION_STATUS.UPLOADED]: STATUS_COLOR.GREEN,
  [VIOLATION_STATUS.APPROVED]: STATUS_COLOR.GREEN,
};

export const VIOLATION_STATUS_LIST = [
  { value: VIOLATION_STATUS.CREATED, nameId: 'violation.status.created' },
  { value: VIOLATION_STATUS.ISSUED, nameId: 'violation.status.issued' },
];

export const getViolationStatusDisplayValue = status => {
  if (!status) {
    return status;
  }
  return status === VIOLATION_STATUS.CREATED ? VIOLATION_STATUS.CREATED : VIOLATION_STATUS.ISSUED;
};

export const EVACUATIONS_STATUS = {
  CREATED: 0,
  IN_PROCESS: 1,
  APPROVED: 2,
  CANCELED: 3,
};

export const EVACUATIONS_STATUS_NAMES = {
  [EVACUATIONS_STATUS.CREATED]: STATUS_COLOR.LIGHT_BLUE,
  [EVACUATIONS_STATUS.IN_PROCESS]: STATUS_COLOR.BLUE,
  [EVACUATIONS_STATUS.APPROVED]: STATUS_COLOR.GREEN,
  [EVACUATIONS_STATUS.CANCELED]: STATUS_COLOR.RED,
};

export const EVACUATIONS_STATUS_LIST = [
  { value: EVACUATIONS_STATUS.CREATED, nameId: 'violation.status.0' },
  { value: EVACUATIONS_STATUS.IN_PROCESS, nameId: 'violation.status.1' },
  { value: EVACUATIONS_STATUS.APPROVED, nameId: 'violation.status.2' },
  { value: EVACUATIONS_STATUS.CANCELED, nameId: 'violation.status.3' },
];

export const VIOLATION_TYPE = {
  PARKING: 'parking',
  SPEEDING: 'speeding',
  ZONE_VIOLATION: 'zone_violation',
  OTHER: 'other',
};

export const VIOLATION_TYPE_LIST = [
  { value: VIOLATION_TYPE.PARKING, nameId: 'violation.type.parking' },
  { value: VIOLATION_TYPE.SPEEDING, nameId: 'violation.type.speeding' },
  { value: VIOLATION_TYPE.ZONE_VIOLATION, nameId: 'violation.type.zone_violation' },
  { value: VIOLATION_TYPE.OTHER, nameId: 'violation.type.other' },
];

export const ZONE_TYPE = {
  PERMITTED: 1,
  CONDITIONAL: 2,
  FORBIDDEN: 3,
};

export const ZONE_TYPE_LIST = [
  { value: ZONE_TYPE.PERMITTED, nameId: 'zone.type.1' },
  { value: ZONE_TYPE.CONDITIONAL, nameId: 'zone.type.2' },
  { value: ZONE_TYPE.FORBIDDEN, nameId: 'zone.type.3' },
];

export const ZONE_STATUS = {
  ACTIVE: 0,
  NOT_ACTIVE: 1,
};

export const ZONE_STATUS_LIST = [
  { value: ZONE_STATUS.ACTIVE, nameId: 'zone.status.0' },
  { value: ZONE_STATUS.NOT_ACTIVE, nameId: 'zone.status.1' },
];

export const SEASON_TYPE = {
  SUMMER: 1,
  AUTUMN: 2,
  WINTER: 3,
  SPRING: 4,
};

export const SEASON_TYPE_LIST = [
  { value: SEASON_TYPE.SUMMER, nameId: 'season.1' },
  { value: SEASON_TYPE.AUTUMN, nameId: 'season.2' },
  { value: SEASON_TYPE.WINTER, nameId: 'season.3' },
  { value: SEASON_TYPE.SPRING, nameId: 'season.4' },
];

export const FILE_FORMAT = {
  CSV: 'csv',
  JSON: 'json',
  XLSX: 'xlsx',
};

export const FILE_FORMAT_LIST = [
  { value: FILE_FORMAT.CSV, nameId: 'file.format.csv' },
  { value: FILE_FORMAT.JSON, nameId: 'file.format.json' },
];

export const WEEKDAYS_ENUM = {
  MON: 0,
  TUE: 1,
  WED: 2,
  THU: 3,
  FRI: 4,
  SAT: 5,
  SUN: 6,
};

export const WEEKDAYS_LIST = [
  { value: WEEKDAYS_ENUM.MON, nameId: 'weekdays.0' },
  { value: WEEKDAYS_ENUM.TUE, nameId: 'weekdays.1' },
  { value: WEEKDAYS_ENUM.WED, nameId: 'weekdays.2' },
  { value: WEEKDAYS_ENUM.THU, nameId: 'weekdays.3' },
  { value: WEEKDAYS_ENUM.FRI, nameId: 'weekdays.4' },
  { value: WEEKDAYS_ENUM.SAT, nameId: 'weekdays.5' },
  { value: WEEKDAYS_ENUM.SUN, nameId: 'weekdays.6' },
];

export const USER_STATUS = {
  ALL: 'all',
  ACTIVE: 'true',
  INACTIVE: 'false',
};

export const USER_STATUS_NAMES = {
  [USER_STATUS.ALL]: STATUS_COLOR.GRAY,
  [USER_STATUS.ACTIVE]: STATUS_COLOR.GREEN,
  [USER_STATUS.INACTIVE]: STATUS_COLOR.GRAY,
};

export const USER_STATUS_LIST = [
  { value: USER_STATUS.ALL, nameId: 'user.status.all' },
  { value: USER_STATUS.ACTIVE, nameId: 'user.status.active' },
  { value: USER_STATUS.INACTIVE, nameId: 'user.status.inactive' },
];

export const ROLE_TYPE = {
  ADMIN: 1,
  INSPECTOR: 2,
  OPERATOR: 3,
};

export const ROLE_TYPE_LIST = [
  { value: ROLE_TYPE.ADMIN, nameId: 'user.role.1' },
  { value: ROLE_TYPE.INSPECTOR, nameId: 'user.role.2' },
  { value: ROLE_TYPE.OPERATOR, nameId: 'user.role.3' },
];

export const GEOGRAPHY_TYPE = {
  MUNICIPAL_BOUNDARY: 'municipal_boundary',
  POLICY_ZONE: 'policy_zone',
  COUNTY_BOUNDARY: 'county_boundary',
  STOP: 'stop',
  COUNCIL_DISTRICT: 'council_district',
  POLITICAL_DISTRICT: 'political_district',
  NEIGHBORHOOD: 'neighborhood',
  MARKET_AREA: 'market_area',
  OPPORTUNITY_ZONE: 'opportunity_zone',
  OVERLAY_DISTRICT: 'overlay_district',
  POST_CODE: 'post_code',
  TRAFFIC_ZONE: 'traffic_zone',
  PROPERTY_LINE: 'property_line',
  RIGHT_OF_WAY: 'right_of_way',
  CENSUS_BLOCK: 'census_block',
  CENSUS_BLOCK_GROUP: 'census_block_group',
  CENSUS_TRACT: 'census_tract',
};

export const GEOGRAPHY_TYPE_LIST = [
  { value: GEOGRAPHY_TYPE.MUNICIPAL_BOUNDARY, nameId: 'geography.type.municipal_boundary' },
  { value: GEOGRAPHY_TYPE.POLICY_ZONE, nameId: 'geography.type.policy_zone' },
  { value: GEOGRAPHY_TYPE.COUNTY_BOUNDARY, nameId: 'geography.type.county_boundary' },
  { value: GEOGRAPHY_TYPE.STOP, nameId: 'geography.type.stop' },
  { value: GEOGRAPHY_TYPE.COUNCIL_DISTRICT, nameId: 'geography.type.council_district' },
  { value: GEOGRAPHY_TYPE.POLITICAL_DISTRICT, nameId: 'geography.type.political_district' },
  { value: GEOGRAPHY_TYPE.NEIGHBORHOOD, nameId: 'geography.type.neighborhood' },
  { value: GEOGRAPHY_TYPE.MARKET_AREA, nameId: 'geography.type.market_area' },
  { value: GEOGRAPHY_TYPE.OPPORTUNITY_ZONE, nameId: 'geography.type.opportunity_zone' },
  { value: GEOGRAPHY_TYPE.OVERLAY_DISTRICT, nameId: 'geography.type.overlay_district' },
  { value: GEOGRAPHY_TYPE.POST_CODE, nameId: 'geography.type.post_code' },
  { value: GEOGRAPHY_TYPE.TRAFFIC_ZONE, nameId: 'geography.type.traffic_zone' },
  { value: GEOGRAPHY_TYPE.PROPERTY_LINE, nameId: 'geography.type.property_line' },
  { value: GEOGRAPHY_TYPE.RIGHT_OF_WAY, nameId: 'geography.type.right_of_way' },
  { value: GEOGRAPHY_TYPE.CENSUS_BLOCK, nameId: 'geography.type.census_block' },
  { value: GEOGRAPHY_TYPE.CENSUS_BLOCK_GROUP, nameId: 'geography.type.census_block_group' },
  { value: GEOGRAPHY_TYPE.CENSUS_TRACT, nameId: 'geography.type.census_tract' },
];

export const GEOGRAPHY_TYPE_COLOR = {
  [GEOGRAPHY_TYPE.MUNICIPAL_BOUNDARY]: '#08A83530',
  [GEOGRAPHY_TYPE.POLICY_ZONE]: '#FFA41F',
  [GEOGRAPHY_TYPE.COUNTY_BOUNDARY]: '#DE0F0F',
  [GEOGRAPHY_TYPE.STOP]: '#DE0F0F50',
  [GEOGRAPHY_TYPE.COUNCIL_DISTRICT]: '',
  [GEOGRAPHY_TYPE.POLITICAL_DISTRICT]: '',
  [GEOGRAPHY_TYPE.NEIGHBORHOOD]: '',
  [GEOGRAPHY_TYPE.MARKET_AREA]: '',
  [GEOGRAPHY_TYPE.OPPORTUNITY_ZONE]: '',
  [GEOGRAPHY_TYPE.OVERLAY_DISTRICT]: '',
  [GEOGRAPHY_TYPE.POST_CODE]: '',
  [GEOGRAPHY_TYPE.TRAFFIC_ZONE]: '',
  [GEOGRAPHY_TYPE.PROPERTY_LINE]: '',
  [GEOGRAPHY_TYPE.RIGHT_OF_WAY]: '#08A83550',
  [GEOGRAPHY_TYPE.CENSUS_BLOCK]: '',
  [GEOGRAPHY_TYPE.CENSUS_BLOCK_GROUP]: '',
  [GEOGRAPHY_TYPE.CENSUS_TRACT]: '',
};

export const GEOGRAPHY_Z_INDEX = {
  [GEOGRAPHY_TYPE.MUNICIPAL_BOUNDARY]: 1,
  [GEOGRAPHY_TYPE.POLICY_ZONE]: 2,
};

export const RULES_TYPE = {
  COUNT: 'count',
  TIME: 'time',
  SPEED: 'speed',
  RATE: 'rate',
  USER: 'user',
};

export const RULES_TYPE_LIST = [
  { value: RULES_TYPE.COUNT, nameId: 'rules.type.count' },
  { value: RULES_TYPE.TIME, nameId: 'rules.type.time' },
  { value: RULES_TYPE.SPEED, nameId: 'rules.type.speed' },
  { value: RULES_TYPE.RATE, nameId: 'rules.type.rate' },
  { value: RULES_TYPE.USER, nameId: 'rules.type.user' },
];

export const RULE_UNITS = {
  SECONDS: 'seconds',
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days',
  AMOUNT: 'amount',
  MPH: 'mph',
  KPH: 'kph',
  DEVICES: 'devices',
};

export const RULE_UNITS_LIST = [
  { value: RULE_UNITS.SECONDS, nameId: 'rules.units.seconds' },
  { value: RULE_UNITS.MINUTES, nameId: 'rules.units.minutes' },
  { value: RULE_UNITS.HOURS, nameId: 'rules.units.hours' },
  { value: RULE_UNITS.DAYS, nameId: 'rules.units.days' },
  { value: RULE_UNITS.AMOUNT, nameId: 'rules.units.amount' },
  { value: RULE_UNITS.MPH, nameId: 'rules.units.mph' },
  { value: RULE_UNITS.KPH, nameId: 'rules.units.kph' },
  { value: RULE_UNITS.DEVICES, nameId: 'rules.units.devices' },
];

export const VEHICLE_TYPES = {
  ALL: 'all',
  BICYCLE: 'bicycle',
  SCOOTER: 'scooter',
  CAR: 'car',
};

export const VEHICLE_TYPES_LIST = [
  { value: VEHICLE_TYPES.ALL, nameId: 'vehicle.types.all' },
  { value: VEHICLE_TYPES.BICYCLE, nameId: 'vehicle.types.bicycle' },
  { value: VEHICLE_TYPES.SCOOTER, nameId: 'vehicle.types.scooter' },
  { value: VEHICLE_TYPES.CAR, nameId: 'vehicle.types.car' },
];

export const VEHICLE_ENTITY_TYPES_LIST = VEHICLE_TYPES_LIST.filter(
  item => item.value !== VEHICLE_TYPES.ALL,
);

export const PROPULSION_TYPES = {
  HUMAN: 'human',
  ELECTRIC_ASSIST: 'electric_assist',
  ELECTRIC: 'electric',
  COMBUSTION: 'combustion',
};

export const PROPULSION_TYPES_LIST = [
  { value: PROPULSION_TYPES.HUMAN, nameId: 'propulsion.types.human' },
  { value: PROPULSION_TYPES.ELECTRIC_ASSIST, nameId: 'propulsion.types.electric_assist' },
  { value: PROPULSION_TYPES.ELECTRIC, nameId: 'propulsion.types.electric' },
  { value: PROPULSION_TYPES.COMBUSTION, nameId: 'propulsion.types.combustion' },
];

export const RATE_RECURRENCES = {
  ONCE_ON_MATCH: 'once_on_match',
  ONCE_ON_UNMATCH: 'once_on_unmatch',
  EACH_TIME_UNIT: 'each_time_unit',
  PER_COMPLETE_TIME_UNIT: 'per_complete_time_unit',
};

export const RATE_RECURRENCES_LIST = [
  { value: RATE_RECURRENCES.ONCE_ON_MATCH, nameId: 'rate.recurrences.once_on_match' },
  { value: RATE_RECURRENCES.ONCE_ON_UNMATCH, nameId: 'rate.recurrences.once_on_unmatch' },
  { value: RATE_RECURRENCES.EACH_TIME_UNIT, nameId: 'rate.recurrences.each_time_unit' },
  { value: RATE_RECURRENCES.PER_COMPLETE_TIME_UNIT, nameId: 'rate.recurrences.per_complete_time_unit' },
];

export const RATE_APPLIES_WHEN = {
  IN_BOUNDS: 'in_bounds',
  OUT_OF_BOUNDS: 'out_of_bounds',
};

export const RATE_APPLIES_WHEN_LIST = [
  { value: RATE_APPLIES_WHEN.IN_BOUNDS, nameId: 'rate.applies.when.in_bounds' },
  { value: RATE_APPLIES_WHEN.OUT_OF_BOUNDS, nameId: 'rate.applies.when.out_of_bounds' },
];

export const DAYS_ENUM = {
  MON: 'mon',
  TUE: 'tue',
  WED: 'wed',
  THU: 'thu',
  FRI: 'fri',
  SAT: 'sat',
  SUN: 'sun',
};

export const DAYS_LIST = [
  { value: DAYS_ENUM.MON, nameId: 'days.mon' },
  { value: DAYS_ENUM.TUE, nameId: 'days.tue' },
  { value: DAYS_ENUM.WED, nameId: 'days.wed' },
  { value: DAYS_ENUM.THU, nameId: 'days.thu' },
  { value: DAYS_ENUM.FRI, nameId: 'days.fri' },
  { value: DAYS_ENUM.SAT, nameId: 'days.sat' },
  { value: DAYS_ENUM.SUN, nameId: 'days.sun' },
];

export const PROVIDER = {
  YANDEX: 'yandex',
};

export const PROVIDER_LIST = [
  { value: PROVIDER.YANDEX, nameId: 'provider.yandex' },
];

export const VEHICLE_STATE = {
  REMOVED: 'removed',
  AVAILABLE: 'available',
  NON_OPERATIONAL: 'non_operational',
  RESERVED: 'reserved',
  ON_TRIP: 'on_trip',
  ELSEWHERE: 'elsewhere',
  UNKNOWN: 'unknown',
};

export const VEHICLE_STATE_LIST = [
  { value: VEHICLE_STATE.REMOVED, nameId: 'vehicle.state.removed' },
  { value: VEHICLE_STATE.AVAILABLE, nameId: 'vehicle.state.available' },
  { value: VEHICLE_STATE.NON_OPERATIONAL, nameId: 'vehicle.state.non_operational' },
  { value: VEHICLE_STATE.RESERVED, nameId: 'vehicle.state.reserved' },
  { value: VEHICLE_STATE.ON_TRIP, nameId: 'vehicle.state.on_trip' },
  { value: VEHICLE_STATE.ELSEWHERE, nameId: 'vehicle.state.elsewhere' },
  { value: VEHICLE_STATE.UNKNOWN, nameId: 'vehicle.state.unknown' },
];

export const VEHICLE_STATE_EVENTS = {
  BATTERY_CHARGED: 'battery_charged',
  ON_HOURS: 'on_hours',
  PROVIDER_DROP_OFF: 'provider_drop_off',
  AGENCY_DROP_OFF: 'agency_drop_off',
  MAINTENANCE: 'maintenance',
  TRIP_END: 'trip_end',
  RESERVATION_CANCEL: 'reservation_cancel',
  TRIP_CANCEL: 'trip_cancel',
  SYSTEM_RESUME: 'system_resume',
  COMMS_RESTORED: 'comms_restored',
  LOCATED: 'located',
  UNSPECIFIED: 'unspecified',
  RESERVATION_START: 'reservation_start',
  TRIP_START: 'trip_start',
  TRIP_ENTER_JURISDICTION: 'trip_enter_jurisdiction',
  TRIP_LEAVE_JURISDICTION: 'trip_leave_jurisdiction',
  CHANGED_GEOGRAPHIES: 'changed_geographies',
  BATTERY_LOW: 'battery_low',
  OFF_HOURS: 'off_hours',
  SYSTEM_SUSPEND: 'system_suspend',
  REBALANCE_PICK_UP: 'rebalance_pick_up',
  MAINTENANCE_PICK_UP: 'maintenance_pick_up',
  AGENCY_PICK_UP: 'agency_pick_up',
  COMPLIANCE_PICK_UP: 'compliance_pick_up',
  DECOMMISSIONED: 'decommissioned',
  MISSING: 'missing',
  COMMS_LOST: 'comms_lost',
};

export const STOPS_TYPE = {
  REMOVED: 'removed',
  AVAILABLE: 'available',
  NON_OPERATIONAL: 'non_operational',
  RESERVED: 'reserved',
  ON_TRIP: 'on_trip',
  ELSEWHERE: 'elsewhere',
  UNKNOWN: 'unknown',
};

export const STOPS_TYPE_LIST = [
  { value: STOPS_TYPE.REMOVED, nameId: 'vehicle.state.removed' },
  { value: STOPS_TYPE.AVAILABLE, nameId: 'vehicle.state.available' },
  { value: STOPS_TYPE.NON_OPERATIONAL, nameId: 'vehicle.state.non_operational' },
];
